// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1UL3L","label":"Section_label__3GS1T","contentWrap":"Section_contentWrap__2pk1I","footer":"Section_footer__1hqkf","footerInner":"Section_footerInner__lzI4Y"};